/**
 * Test IDs for QA automation.
 */
export const testIds = {
  bulkActionModalCancel: "bulk-action-modal-cancel",
  bulkActionModalSave: "bulk-action-modal-save",
} as const;
